export enum PermissionMenuType {
  EXPAND_COLLAPSE_ALL = 'EXPAND_COLLAPSE_ALL',
  RESTORE_DEFAULT_PERMISSIONS = 'RESTORE_DEFAULT_PERMISSIONS',
  DOWNLOAD_CSV = 'DOWNLOAD_CSV',
}

export interface PermissionMenu {
  label: string;
  type: PermissionMenuType;
}

export interface PermissionActionsProps {
  onMenuSelect: (menuType: PermissionMenuType) => void;
}
